// removed by extract-text-webpack-plugin
module.exports = {"app":"App__app___3P8ep","audioItemRenderer":"App__audioItemRenderer___3gfZM"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/App.scss
 ** module id = 290
 ** module chunks = 0
 **/